module.exports = __webpack_public_path__ + "static/img/goods-list-img03.4a198433.svg";